import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap'
import Card from '../../Card/Card'
import { inputChangeHandler, columnFilters, createSortString, getFormattedDate } from 'helper/helperFunctions'
import { Link } from 'react-router-dom'
import { getPreShipmentEmailList } from 'redux/actions/order-actions'
import Pagination from '../../ThemeComponents/Pagination'
import { orderService } from "../../../services/order";


class WtkPreShipmentEmailList extends Component {
    constructor(props) {
        super(props);
        this.inputChangeHandler = inputChangeHandler.bind(this);
        this.state = {
            filtered: '',
            pageSize: 100
        }
    }
    getRowProps(rowData) {
		let data = {};
		if (rowData.numberOfDays <= 48) {
			data = { color: 'red' }
		}

		if (rowData.numberOfDays >= 49 && rowData.numberOfDays <= 54) {
			data = { color: 'Black' }
		}

		return data;
	}

    paginationCall = (data) => {
        let matchFilterWith;
        if (this.pagination) {
            if (this.pagination.reactTable) {
                matchFilterWith = columnFilters(this.pagination.reactTable.state.columns[0].columns)
            }
        }
        let sorted = data.sort.split(',');
        let { sort, orderType } = createSortString(sorted)
        return orderService.getPreShipmentEmailListWtk(data.page, data.filter, sort, data.pageSize, orderType, matchFilterWith);
    }

    render() {
        const columns = [
            {
                Header: 'Program Types',
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: 'Barcode',
                        accessor: 'barcode',
                        className: 'action-center',
                        sortable: true,
                        width: 200,
                        Cell: ({ value, original }) => {
                            return <Link target='_blank' to={`/Admin/${original.id}/order-edit?commentCategoryCode=ContactLog#commentTabs`} className='blue_link'>{value}</Link>
                        }
                    },
                    {
                        Header: 'Group Name',
                        accessor: 'group_name',
                        className: 'justifyStart',
                        sortable: true,
                    },
                    {
                        Header: 'Contact',
                        id: 'groupLeaderContact.first_name',
                        accessor: 'group_leader_contact.first_name',
                        className: 'justifyStart',
                        sortable: true,
                    },
                    {
                        Header: 'Pre-Trip Materials Ship Date',
                        id: 'orderDateSingle.projected_camera_ship_date.value',
                        accessor: 'order_dates.projected_camera_ship_date.value',
                        className: 'action-center',
                        sortable: true,
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                    {
                        Header: 'Departure Date',
                        id: 'orderDateSingle.departure_date.value',
                        accessor: 'order_dates.departure_date.value',
                        className: 'action-center',
                        sortable: true,
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                    {
                        Header: 'Number of Days',
                        accessor: 'numberOfDays',
                        className: 'action-center',
                        sortable: true,
                    },
                    {
                        Header: 'Ship State',
                        accessor: 'pre_trip_material_address.state.code',
                        className: 'action-center',
                        sortable: false,
                    },
                    {
                        Header: 'Contact Log',
                        className: 'action-center',
                        sortable: false,
                        Cell: ({ value, original }) => {
                            return <Link target='_blank' to={`/Admin/${original.id}/order-edit?commentCategoryCode=ContactLog#commentTabs`} className='blue_link'>Contact Log</Link>
                        }
                    },
                    {
                        Header: 'Last Contact Log Entry',
                        accessor: 'comments[0].created_at',
                        className: 'action-center',
                        sortable: false,
                        Cell: ({ value }) => {
                            return getFormattedDate(value)
                        }
                    },
                ]
            }
        ]
        const { /*preShipmentEmailList, days_from_now*/ } = this.props;
        return (
            <div className='content'>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card content={
                                <React.Fragment>
                                    <div className="secHeading">WTK Pre Shipment Email List</div>
                                    <div className='row'>
                                        <Pagination
                                            ref={(p) => this.pagination = p}
                                            showPagination={false}
                                            columns={columns}
                                            pageSize={100}
                                            getDataCall={this.paginationCall}
                                            filterView={false}
                                            // downloadData={true}
                                            // downloadFileName={'Orders'}
                                            // lowerContent = {null}
                                            // filterPlaceHolder = {'Orders'}
                                            getRowProps={this.getRowProps}
                                            // showAllToggle={true}
                                        />
                                    </div>
                                </React.Fragment>
                            } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { preShipmentEmailList, days_from_now } = state.ordersReducer;
    return {
        preShipmentEmailList,
        days_from_now
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPreShipmentEmailList: (page, filter, sort, pageSize, orderType, matchFilterWith) => { return dispatch(getPreShipmentEmailList(page, filter, sort, pageSize, orderType, matchFilterWith)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WtkPreShipmentEmailList)
